module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"expand_review":"查看更多","collapse_review":"显示较少","user_display_name_message_html":"<b>%{user_display_name}</b>的评论。","user_grade":"用户等级","author_grade":"创建者等级"}}')
  delete Component.options._Ctor
}
